
import useHTMLTitle from "../hooks/useHTMLTitle";
import { UIWhiteBox } from "../ui/UIContainer";
import UIFlex, { copyFlex } from "../ui/UIFlex";
import View from "./View";
import './LoginView.scss';
import Flex from "../data/Flex";
import UITitle from "../ui/UITitle";
import Size from "../data/Size";
import UIInput from "../ui/UIInput";
import UIButton from "../ui/UIButton";
import useValueName from "../hooks/useValueName";
import UIStatusBanner from "../ui/UIStatusBanner";
import LoadingOverlay from "../ui/overlay/LoadingOverlay";
import Api from "../api/Api";
import { Navigate, useNavigate } from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import { UIForm } from "../ui/UIForm";
import Color from "../data/Color";
import PasswordResetOverlay from "../ui/overlay/PasswordResetOverlay";
import FormatUtil,{IHash} from '../util/FormatUtil';
import ConfirmOverlay from "../ui/overlay/ConfirmOverlay";

export interface ILoginViewProps {

}


LoginView.TITLE = "Login";
LoginView.PATH = "/login";
LoginView.ID = "login";


interface ILoginViewState{
    email:string;
    password:string;
    showEnv:boolean;
    env:string;
    org:string;
    error?:string;
    outro:boolean;
}

export default function LoginView($props:ILoginViewProps){

    useHTMLTitle(LoginView.TITLE);

    const [vnValues, setValue, setValueState] = useValueName({
        email:"",
        password:"",
        env:Api.strEvnURL,
        org:"",
        showEnv:false,
        outro:false,
    });
    const vnState:ILoginViewState = vnValues;

    const setError = ($value:string | number | boolean)=>{
        setValue($value,"error");
    }

    const navigate = useNavigate();

    const _submit = ()=>{
        if(!vnState.outro){

            let email = vnState.email.trim();
            let password = vnState.password.trim();
    
            let isEmailValid:boolean=false;

            isEmailValid = FormatUtil.isValidEmail(email) && email!=="";
    
            if(email===""){
                setError("You must enter an email.");
                return;
            }
            if(password===""){
                setError("You must enter a password.");
                return;
            }

            if(!isEmailValid){
                setError("You must enter a valid Email address.");
                return;
            }   
    
            const hideLoading = LoadingOverlay.show("loginLoading",{desc:"Logging In"});

            const encodedPassword: IHash = FormatUtil.encodePassword(vnState.email, vnState.password);

            Api.access.userLogin(($success,$result)=>{
                if($success){
                    setValue(true,"outro");
                    
                    console.log("login results");
                    console.log($result);

                    localStorage.setItem("token",$result.token);
                    localStorage.setItem("user",JSON.stringify($result));

                    window.setTimeout(()=>{
                        navigate(Dashboard.PATH);
                        window.setTimeout(()=>{
                           // hideLoading();

                        },500);
                    },500);
                }else{
                    hideLoading();
                    setError($result.error);
                }
            },{email:email,password:encodedPassword.wireHash,epocTime:String(encodedPassword.epocTime)});
        }

    }

    const _reset=()=>{  
        PasswordResetOverlay.show("Reset Password",{title:"",desc:"Reset Password",sendLabel:"SEND EMAIL"});
    }         

    let extraCN:string = "";
    if(vnState.outro){
        extraCN+=" outro";
    }

    return (
        <View id={LoginView.ID} className={extraCN} flex={{alignItems:Flex.CENTER, justifyContent:Flex.CENTER}}>
            <UIWhiteBox animateIntro animateIntroDelay={1} className="loginModal">
                <UIFlex className="loginModalHeader" flex={{alignItems:Flex.CENTER, justifyContent:Flex.CENTER}}>
                    <div className="logo"/>
                    <UITitle fontSize={Size.s20} title="PSAP Link"/>
                </UIFlex>
                <UITitle fontSize={Size.s18} flex={{alignItems:Flex.CENTER, justifyContent:Flex.CENTER}} className="actionTitle" title="Log In"/>
                {vnState.error && (
                    <UIStatusBanner onClose={()=>{
                        setError("");
                    }} status={{type:UIStatusBanner.TYPE_ERROR, id:"error",content:vnState.error}} />
                )}
                <UIForm>

                    {vnState.email==="debug" && (
                        <>
                            <UIInput style={UIInput.STYLE_LABEL_AS_PLACEHOLDER} value={vnState.env} onChange={($value,$name)=>{
                                Api.strEnvName = $name as string;
                                Api.strEvnURL = $value as string;
                                setValue($value,$name);
                            }} name="env" type={UIInput.TYPE_SELECT} options={Api.arrEnvironments}/>

                            <UIInput style={UIInput.STYLE_LABEL_AS_PLACEHOLDER} value={vnState.org} onChange={($value,$name)=>{
                                Api.strOrgName = $name as string;
                                Api.strOrg = $value as string;
                                setValue($value,$name);
                            }} name="org" type={UIInput.TYPE_SELECT} options={Api.arrOrgs}/>
                        </>
                    )}

                     
                    <UIInput style={UIInput.STYLE_LABEL_AS_PLACEHOLDER} isRequired label="Email" name="email" value={vnState.email} onChange={setValue} />
                    <UIInput style={UIInput.STYLE_LABEL_AS_PLACEHOLDER} isRequired label="Password" name="password" type={UIInput.TYPE_PASSWORD} value={vnState.password} onChange={setValue}/>


                    <UIButton flex={{fullWidth:true}} useButton size={Size.s52} label="LOG IN" dropShadow onClick={_submit}/>



                    <UIFlex flex={{fullWidth:true, style:{marginBottom:-40, flexShrink:0, marginLeft:-20}}}>
                        <UIFlex flex={{style:{flexGrow:1}}}>
                            <UIButton label="Forgot your password?"  color={Color.RED_PRIMARY} flex={{style:{padding:10}, direction:Flex.COLUMN}} onClick={()=>{
                            _reset();
                             }}/>
                        </UIFlex>
                    </UIFlex>
                </UIForm>
                
                <div className="dragonFlyAni"/>
                
            </UIWhiteBox>
            
        </View>
    )
}
